<div class="container sidebar">
	<button type="button" (click)="open()">Abrir modal</button>
</div>
